import { message } from 'antd';
import * as ACTIONS from 'app/actions/CotplayHubActions';

const initialState = {
    listMedia: [],
    isLoadingMedia: false,
    filter: {

    },
    pagination: {
        current: 1,
        pageSize: 10,
        total: 0
    },
    trainingType: [],
    isLoadingTraining: false,
    systemSpecialty: [],
    isLoadingSystemSpecialty: false,
    filtersListMedia: []
}

export const CotplayHubReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.GET_MULTIMEDIA_REQUEST:
            return {
                ...state,
                isLoadingMedia: true
            }
        case ACTIONS.GET_MULTIMEDIA_FILTERS:
            return {
                ...state,
                filtersListMedia: action.payload,             
            }
        case ACTIONS.GET_MULTIMEDIA_SUCCESS:
            return {
                ...state,
                isLoadingMedia: false,
                listMedia: action.payload,
                pagination: {
                    current: (action.params.offset / action.params.limit) + 1,
                    pageSize: action.params.limit,
                    total: action.payload.length > 0 ? action.payload[0].totalCount : 0,
                }
            }
        case ACTIONS.GET_MULTIMEDIA_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingMedia: false,
            }

        // Training:
        case ACTIONS.GET_MULTIMEDIA_TRAINING_REQUEST:
            return {
                ...state,
                isLoadingTraining: true
            }

        case ACTIONS.GET_MULTIMEDIA_TRAINING_SUCCESS:
            return {
                ...state,
                isLoadingTraining: false,
                trainingType: action.payload
            }

        case ACTIONS.GET_MULTIMEDIA_TRAINING_SUCCESS:
            message.error(action.payload);
            return {
                ...state,
                isLoadingTraining: false,
            }

        // Specialty Training Media:
        case ACTIONS.GET_MULTIMEDIA_SPECIALTY_TRAINING_REQUEST:
            return {
                ...state,
                isLoadingSystemSpecialty: true
            }

        case ACTIONS.GET_MULTIMEDIA_SPECIALTY_TRAINING_SUCCESS:
            return {
                ...state,
                isLoadingSystemSpecialty: false,
                systemSpecialty: action.payload
            }

        case ACTIONS.GET_MULTIMEDIA_SPECIALTY_TRAINING_SUCCESS:
            message.error(action.payload);
            return {
                ...state,
                isLoadingSystemSpecialty: false,
            }

        case ACTIONS.SAVE_FILTER_COTPLAYHUB:
            return {
                ...state,
                filter: action.payload
            }

        //Finaliza el video
        case ACTIONS.FINISHED_MEDIA_HUB_REQUEST:
            return state;
        case ACTIONS.FINISHED_MEDIA_HUB_SUCCESS:
            message.success("Video finalizado con éxito");
            return state;
        case ACTIONS.FINISHED_MEDIA_HUB_FAILURE:
            message.error(action.payload);
            return state;
        // actualuza el numero de vistas del video
        case ACTIONS.FINISHED_MEDIO_HUB_RELOAD_VIEWS:
            return {
                ...state,
                listMedia: state.listMedia.map(item => item.idCourse === action.payload.idCourse
                    ? { ...item, replays: action.payload.views }
                    : item
                )

            }

        default:
            return state;
    }
}

